import { Box, Modal, Stack, Typography } from "@mui/material";
import Loader from "../../common/Loader";

const LanguageProcessModal = ({ open }) => {
  return (
    <Modal open={open}>
      <Box className="user-modal-responsive">
        <Stack spacing={1} direction={"column"} alignItems={"center"}>
          <Typography variant="h6">Processing please wait</Typography>
          <Typography variant="body1">
            We are processing the language you have selected. Please wait.
          </Typography>
        </Stack>
        <Box sx={{ mt: 2, display: "flex", justifyContent: "center" }}>
          <Loader />
        </Box>
      </Box>
    </Modal>
  );
};

export default LanguageProcessModal;
